import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { SocketService } from './socket.service';
import { concatMap, map, mergeMap, tap } from 'rxjs/operators';
import { ChangeFollowStatus, ClearChatHistory, GetFollowStatus, GetRecentlyRecords, GetRecentlyRecordsByUser, GetRecentlyRecordsComplete, GetSettings, LoadPreviousRecords, MarkAllMessagesAsRead, MarkMessagesAsRead, RemoveContact, Report, SelectContact, SendMessage, SendMessageFailure } from './socket.actions';
import { Observable } from 'rxjs';
import { SocketActionTypes } from './socket.actions';
import { SocketFacade } from './socket.facade';
import { DnDialogService } from '../dn-dialog/dn-dialog.service';
import { UploadService } from '../../_service/upload/upload.service';
import { ConfirmDialogState, ConfirmDialogService } from '../../components/dialogs/confirm-dialog/confirm-dialog.service';
import { SettingsService } from '../../user-center/settings/settings.service';

@Injectable()
export class SocketEffects {


    @Effect({ dispatch: false })
    SendMessage$: Observable<any> = this.actions$.pipe(
        ofType<SendMessage>(SocketActionTypes.SendMessage),
        mergeMap((action) =>
            this.socketService.sendMessage({
                context: action['payload'].message,
                toUid: action['payload'].toUid,
                code: action['payload'].code
            })
                .pipe(map(r => { return { action, result: r } }))
        ),
        map((res) => {
            if (res.result.data.code !== 0) {
                return this.socketFacade.sendMessageFailure({ message: res.result.data.msg, action: res.action });
            } else {
                return this.socketFacade.sendMessageSuccess(
                    {
                        ...res.result.data.info[0],
                        messageType: res.result.data.info[0].messageType === 1 ? 'text' : 'image',
                        processContext: res.result.data.info[0].messageType === 1
                            ? res.result.data.info[0].processContext
                            : res.result.data.info[0].context,
                    }
                )
            }
        })
    );
    @Effect({ dispatch: false })
    sendMessageFailure$: Observable<any> = this.actions$.pipe(
        ofType<SendMessageFailure>(SocketActionTypes.SendMessageFailure),
        map((action) => {
            const confirmFormId = 'delete-messages';
            const dialogId = 'confirm-dialog';
            if (action.payload.message === "消息内含有敏感词汇，发送失败") {
                return this.socketFacade.sentMessageNotAllowed({
                    context: action.payload.action.payload.message,
                    uid: action.payload.action.payload.toUid,
                    HeadImg: action.payload.action.payload.HeadImg,
                    type: "SEND",
                    // sendTime: Math.floor(((new Date()).getTime() + 3600000) / 1000),
                    sendTime: Math.floor(((new Date()).getTime()) / 1000),
                    notAllowed: true
                })
            } else if (action.payload.message === "绑定手机号后才可以发私信哟~") {
                this._confirmDialogService.setState(
                    {
                        id: confirmFormId,
                        message: `<h5>${action.payload.message}</h5>`,
                        showIcon: false,
                        state: ConfirmDialogState.Unknown,
                        okText: "取消",
                        cancelText: "绑定手机号",
                    });
                this._dnDialogService.open(dialogId);
                const deleteSubscribe = this._confirmDialogService.confirmDialogSource$.subscribe(r => {

                    if (r.state !== ConfirmDialogState.Unknown) {
                        this._dnDialogService.close(dialogId);
                        deleteSubscribe.unsubscribe();
                    }
                    if (r.state === ConfirmDialogState.Cancalled && r.id === confirmFormId) {
                        window.open("https://www.anygate.vip/User/Bind", "_blank");
                        this._dnDialogService.close(dialogId);
                        deleteSubscribe.unsubscribe();
                    }
                })
            } else {
                // this._messageDialogService.setState({ message: action.payload.message });
                this._dnDialogService.open('message-dialog', { buttonText: '知道了',message: action.payload.message  });
            }
        })
    );
    @Effect({ dispatch: false })
    GetRecentlyRecords$: Observable<any> = this.actions$.pipe(
        (ofType<GetRecentlyRecords>(SocketActionTypes.GetRecentlyRecords)),
        concatMap(() => this.socketService.getRecentlyRecords()),
        map((result) => {
            return this.socketFacade.getRecentlyRecordsComplete(result);
        })
    );
    @Effect({ dispatch: false })
    GetRecentlyRecordsByUser$: Observable<any> = this.actions$.pipe(
        (ofType<GetRecentlyRecordsByUser>(SocketActionTypes.GetRecentlyRecordsByUser)),
        concatMap(action => this.socketService.getRecentlyRecordsByUser(
            action.payload.uid,
            action.payload.messageId,
            10,
            action.payload.currentUser
        )),
        map((result: any) => {
            return this.socketFacade.getRecentlyRecordsByUserComplete({
                ...result,
            });
        })
    );
    @Effect({ dispatch: false })
    MarkMessagesAsRead$: Observable<any> = this.actions$.pipe(
        (ofType<MarkMessagesAsRead>(SocketActionTypes.MarkMessagesAsRead)),
        tap((action) => {
            return this.socketService.markMessagesAsRead(action.payload.uid).subscribe();
        })
    );
    @Effect({ dispatch: false })
    MarkAllMessagesAsRead$: Observable<any> = this.actions$.pipe(
        (ofType<MarkAllMessagesAsRead>(SocketActionTypes.MarkAllMessagesAsRead)),
        tap((action) => {
            return this.socketService.markAllMessagesAsRead().subscribe();
        })
    );
    @Effect({ dispatch: false })
    ClearChatHistory$: Observable<any> = this.actions$.pipe(
        (ofType<ClearChatHistory>(SocketActionTypes.ClearChatHistory)),
        tap((action) => {
            return this.socketService.clearChatHistory(action.payload).subscribe();
        })
    );
    @Effect({ dispatch: false })
    RemoveContact$: Observable<any> = this.actions$.pipe(
        (ofType<RemoveContact>(SocketActionTypes.RemoveContact)),
        tap((action) => {
            return this.socketService.removeContact(action.payload).subscribe();
        })
    );
    @Effect({ dispatch: false })
    getSettings$: Observable<any> = this.actions$.pipe(
        (ofType<GetSettings>(SocketActionTypes.GetSettings)),
        concatMap(() => this.socketService.getSettings()),
        map((result) => {
            return this.socketFacade.getSettingsSuccess({ friendOnly: result });
        })
    );
    @Effect({ dispatch: false })
    toggleSettingsFriendOnly$: Observable<any> = this.actions$.pipe(
        (ofType(SocketActionTypes.ToggleSettingsFriendOnly)),
        tap((action) => {
            return this.socketService.toggleSettingsFriendOnly().subscribe(
                result => {
                    const friendOnly = result.includes('已启用');
                    // 收到回调后，向setting服务更新
                    this.settingsService.updateOneSetting({isFriendOnly: friendOnly});
                }
            );
        })
    );
    @Effect({ dispatch: false })
    report$: Observable<any> = this.actions$.pipe(
        ofType<Report>(SocketActionTypes.Report),
        mergeMap((action) => this.socketService.report(action.payload)),
        map((res) => {
            // this._messageDialogService.setState({ message: res.msg });
            this._dnDialogService.open('message-dialog', { buttonText: '知道了',message: res.msg  });
        })
    )
    @Effect({ dispatch: false })
    getFollowStatus$: Observable<any> = this.actions$.pipe(
        ofType<GetFollowStatus>(SocketActionTypes.GetFollowStatus),
        concatMap((action) => this.socketService.getFollowStatus(action.payload)),
        map((res) => {
            return this.socketFacade.getFollowStatusSuccess(res);
        })
    )
    @Effect({ dispatch: false })
    changeFollowStatus$: Observable<any> = this.actions$.pipe(
        ofType<ChangeFollowStatus>(SocketActionTypes.ChangeFollowStatus),
        concatMap((action) => {
            return this.uploadService.SetAttension(action.payload)
        }),
        map((res) => {
            return this.socketFacade.changeFollowStatusSuccess(res);
        })
    )


    constructor(
        private actions$: Actions,
        private socketService: SocketService,
        private socketFacade: SocketFacade,
        private _confirmDialogService: ConfirmDialogService,
        private _dnDialogService: DnDialogService,
        private uploadService: UploadService,
        private settingsService: SettingsService,
    ) {

    }
}
